var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-video"},[_c('video',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"myVideo",staticClass:"video",attrs:{"controls":"","src":_vm.itemData.url},on:{"waiting":_vm.handleWaiting,"canplay":_vm.handleCanplay}})])
}
var staticRenderFns = []

export { render, staticRenderFns }